var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14254_23316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14254_23316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.34375 11.1751H13.3437V4.50846H5.34375V11.1751ZM5.34375 12.5085C4.97708 12.5085 4.66319 12.3779 4.40208 12.1168C4.14097 11.8557 4.01042 11.5418 4.01042 11.1751V3.17513C4.01042 2.80846 4.14097 2.49457 4.40208 2.23346C4.66319 1.97235 4.97708 1.8418 5.34375 1.8418H13.3437C13.7104 1.8418 14.0243 1.97235 14.2854 2.23346C14.5465 2.49457 14.6771 2.80846 14.6771 3.17513V11.1751C14.6771 11.5418 14.5465 11.8557 14.2854 12.1168C14.0243 12.3779 13.7104 12.5085 13.3437 12.5085H5.34375ZM2.67708 15.1751C2.31042 15.1751 1.99653 15.0446 1.73542 14.7835C1.47431 14.5224 1.34375 14.2085 1.34375 13.8418V4.50846H2.67708V13.8418H12.0104V15.1751H2.67708Z",
    fill: "#34629D",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.2ad82b795ddd8f6bb5998298938176b3.svg";
export { ForwardRef as ReactComponent };